export default __webpack_public_path__ + "static/media/pen.376f53c9.svg";